import { add } from 'ramda';
import { useState, useEffect } from 'react';
import { isMobile } from '../../theme/media';

export const useLazyLoading = items => {
  const threshold = isMobile() ? 10 : 15;
  const [state, setState] = useState({ lastItemIndex: threshold });

  useEffect(() => {
    setState(() => ({
      lastItemIndex: threshold,
    }));
  }, [items, threshold]);

  const loadMore = () =>
    setState(prevState => ({
      lastItemIndex: add(prevState.lastItemIndex, threshold),
    }));

  const visibleItems = items.slice(0, state.lastItemIndex);

  return [
    {
      visibleItems,
      threshold,
      lastItemIndex: state.lastItemIndex,
      allItemsVisible: visibleItems.length === items.length,
    },
    loadMore,
  ];
};
